import { render } from "./RestaurantEditOrder.vue?vue&type=template&id=1234c261"
import script from "./RestaurantEditOrder.vue?vue&type=script&lang=js"
export * from "./RestaurantEditOrder.vue?vue&type=script&lang=js"

import "./RestaurantEditOrder.vue?vue&type=style&index=0&id=1234c261&lang=css"

import exportComponent from "/Users/wouter/Vue-apps/BRGR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__